// extracted by mini-css-extract-plugin
export default {"label":"formSelect_label__WUxY-","select":"formSelect_select__AC7Ws"};